import React from 'react'
import FranchiseFormPage from '../../components/Merchant/FranchiseForm';

const FranchiseForm = () => {
  return (
    <FranchiseFormPage />
  )
}

export default FranchiseForm;